export default () => 
  `<div class="content"> 
    Height from ground to top of module on the North side(i.e., the lowest edge side) 
  </div>
`;
